import React, { FC, ReactNode } from 'react';
import { Grid, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { BlueCheckIcon } from 'svgs';

export interface FeatureItemProps {
  svgIcon: ReactNode;
  title: string;
  text: string;
  underText?: string;
  animationDelay: number;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    imageIcon: {
      '& svg': {
        maxHeight: 50,
        width: 50,
        [theme.breakpoints.up(375)]: {
          maxHeight: 57,
          width: 57,
          marginRight: 5,
        },
        [theme.breakpoints.up('sm')]: {
          maxHeight: 78,
          width: 78,
          marginRight: 0,
        },
      },
    },
    contentWrapper: {
      marginTop: theme.spacing(2),
      [theme.breakpoints.up(375)]: {
        marginTop: theme.spacing(3),
      },
      [theme.breakpoints.up('sm')]: {
        marginTop: theme.spacing(4),
      },
    },
    title: {
      color: theme.palette.common.black,
      fontWeight: 500,
      [theme.breakpoints.up('md')]: {
        lineHeight: '36px',
        maxWidth: 320,
      },
    },
    text: {
      marginBottom: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(4),
      },
    },
    underText: {
      display: 'inline-flex',
      alignItems: 'center',
    },
    checkSvg: {
      maxWidth: 15,
      marginRight: theme.spacing(1),
      [theme.breakpoints.up(375)]: {
        maxWidth: 22,
        marginRight: theme.spacing(2),
      },
    },
  };
});

const FeatureItem: FC<FeatureItemProps> = ({ animationDelay, svgIcon, text, title, underText }) => {
  const classes = useStyles();
  const isSmallUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));

  return (
    <div data-aos="fade-up" data-aos-delay={animationDelay}>
      <Grid wrap="nowrap" container direction="row" justify="center" alignItems="flex-start" spacing={isSmallUp ? 6 : 2}>
        <Grid item className={classes.imageIcon}>
          {svgIcon}
        </Grid>
        <Grid item className={classes.contentWrapper}>
          <Typography className={classes.title} variant="h3" gutterBottom>
            {title}
          </Typography>
          <Typography color={'textPrimary'} variant="h4" className={classes.text}>
            {text}
          </Typography>
          {!!underText && (
            <Typography color={'primary'} variant="h4" component="p" className={classes.underText}>
              <BlueCheckIcon className={classes.checkSvg} width="100%" viewBox="0 0 22 22" />
              <span>{underText}</span>
            </Typography>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default FeatureItem;
